import React from "react";
import { ArticleAppendixVersion } from "../../../../amorg-common";
import { Button } from "../../../../designSystem/button/Button";
import { Card } from "../../../../designSystem/Card";
import { AnimatedCollapsibleContent } from "../../../../designSystem/collapsible/AnimatedCollapsibleContent";
import { Flex } from "../../../../designSystem/compositeComponents/FlexHelpers";
import { FormField } from "../../../../designSystem/formField/FormField";
import { Modal } from "../../../../designSystem/Modal";
import { Table, TableRowWithOnClick } from "../../../../designSystem/Table";
import { H3 } from "../../../../designSystem/typography/Heading";
import { TextAvatar } from '../../../../designSystem/avatar/TextAvatar';

type AppendixPanelProps = {
    appendices: ArticleAppendixVersion[]
};
export function AppendixPanel (props: AppendixPanelProps): JSX.Element
{
    const [show, setShow] = React.useState<boolean>(false);
    const [showAppendixId, setShowAppendixId] = React.useState('');

    React.useEffect(() =>
    {
        const newShow = props.appendices.length > 0;
        if (show !== newShow)
            setShow(newShow);
    }, [props.appendices]);

    return (
        <Flex flexDirection="column">
            <Flex>
                <Flex gap={8} style={{ flexGrow: 1 }}>
                    <H3>Ændringsbekendtgørelser</H3>
                    {props.appendices.length > 0 &&
                        <TextAvatar text={props.appendices.length.toString()} />}
                </Flex>
                <Button variant='text' icon={show ? 'caret_caretUp' : 'caret_caretDown'} onClick={() => setShow(!show)} />
            </Flex>
            <AnimatedCollapsibleContent open={show}>
                <Card variant="outlined">
                <Flex flexDirection="column" gap={16}>
                    <Table>
                        <thead>
                            <tr>
                                <th>Titel</th>
                                <th>Type</th>
                                <th>Emne</th>
                                <th>Lovnummer</th>
                            </tr>
                        </thead>
                        <tbody>
                            {props.appendices.length === 0 &&
                                <tr>
                                    <td colSpan={4}>Der er ingen ændringsbekendtgørelser</td>
                                </tr>}
                            {props.appendices.sort((a, b) => {
                                return (b.date?.getTime() ?? -Infinity) - (a.date?.getTime() ?? -Infinity)
                            }).map((appendix) => 
                                <TableRowWithOnClick key={appendix.id} onClick={() => setShowAppendixId(appendix.id)}>
                                    <td>{appendix.title}</td>
                                    <td>{appendix.type.name}</td>
                                    <td>{appendix.topic.name}</td>
                                    <td>{appendix.reference}</td>
                                </TableRowWithOnClick>
                            )}
                        </tbody>
                    </Table>

                    <ViewAppendixModal appendix={props.appendices.find(a => a.id === showAppendixId)} onClose={() => setShowAppendixId('')} />

                </Flex>
                </Card>

            </AnimatedCollapsibleContent>
        </Flex>
    );
}

type ViewAppendixModalProps = {
    appendix?: ArticleAppendixVersion,
    onClose(): void;
}
export function ViewAppendixModal (props: ViewAppendixModalProps): JSX.Element
{

    return (
        <>
            {props.appendix &&
                <Modal title='Ændringsbekendtgørelse' showModal={true} onCancel={props.onClose}
                    content={
                        <Flex flexDirection='column' gap={16}>

                            <FormField
                                label='Titel'
                                inputComponent={<span>{props.appendix.title}</span>}
                            />
                            <FormField
                                label='Lovnummer'
                                inputComponent={<span>{props.appendix.reference}</span>}
                            />

                            <FormField
                                label='Webaddresse'
                                inputComponent={
                                    <>
                                        {props.appendix.url &&
                                            <a href={props.appendix.url.toLowerCase().startsWith('www')
                                                    ? `http://${props.appendix.url}`
                                                    : props.appendix.url
                                            } target='_blank' rel='noreferrer'>Gå til webaddressen</a>
                                        }
                                        {!props.appendix.url &&
                                            <span>ikke angivet</span>
                                        }
                                    </>
                                }
                            />

                            <FormField
                                label='Type lovkrav'
                                inputComponent={<span>{props.appendix.type.name}</span>}
                            />

                            <FormField
                                label='Liste/emne'
                                inputComponent={<span>{props.appendix.topic.name}</span>}
                            />

                            <FormField
                                label='Dato'
                                inputComponent={<span>{props.appendix.date?.toLocaleDateString()}</span>}
                            />

                            <FormField
                                label='Beskrivelse'
                                inputComponent={<span>{props.appendix.description}</span>}
                            />
                        </Flex>
                    } />
                }
        </>
    );
}